export default __webpack_public_path__ + "static/media/CampusToCorporate.2d51a107.png";